import { render, staticRenderFns } from "./checkDistrictManage.vue?vue&type=template&id=c1fd94bc&scoped=true&"
import script from "./checkDistrictManage.vue?vue&type=script&lang=js&"
export * from "./checkDistrictManage.vue?vue&type=script&lang=js&"
import style0 from "./checkDistrictManage.vue?vue&type=style&index=0&id=c1fd94bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fd94bc",
  null
  
)

export default component.exports